export const customtableStyles = (
  headBg = "#F8F8F8",
  headColor = "#333333",
  rowColor = "var(--row-color)",
  textColor = "var(--text-color)"
) => ({
  headRow: {
    style: {
      backgroundColor: headBg,
      color: headColor,
      fontWeight: "bold",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: headColor,
      margin: "0px",
    },
  },
  rows: {
    style: {
      color: textColor,
      height: "60px",
      "&:nth-child(2n)": {
        backgroundColor: rowColor,
      },
      "&:nth-child(2n+1)": {
        backgroundColor: "var(--row-color)",
      },
    },
  },
});

export const customdocStyles = {
  headRow: {
    style: {
      borderRadius: "30px",
      backgroundColor: "var(--table-header)",
      color: "var(--text-color)",
      fontWeight: "bold",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: "white",
      margin: "0px",
    },
  },

  rows: {
    style: {
      borderRadius: "30px",
      color: "var(--text-color)",
      height: "100px",
      "&:nth-child(2n)": {
        backgroundColor: "var(--row-color)",
      },
    },
  },
};
export const custometableStylesmatches = {
  headRow: {
    style: {
      borderRadius: "30px",
      backgroundColor: "#101713",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: "white",
      center: true,
    },
  },
  rows: {
    style: {
      borderRadius: "30px",
      color: "#bbb",
    },
  },
};
export const custometableStylesdashboard = {
  headRow: {
    style: {
      borderRadius: "30px",
      backgroundColor: "#101713",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: "white",
      width: "200px",
      center: true,
    },
  },
  rows: {
    style: {
      borderRadius: "30px",
      color: "#bbb",
    },
  },
};

export const conditionalRowStyles = [
  {
    when: (row) => row,
    style: {
      "&:hover": {
        cursor: "pointer",
        color: "var( --active-border)",
      },
    },
  },
  {
    when: (row) => row?.isSummary,
    style: {
      backgroundColor: "#f5f5f5",
      borderTop: "1px solid #ccc",
      "& div": {
        fontWeight: "bold",
      },
      "&:hover": {
        backgroundColor: "#f5f5f5", // prevent highlight
      },
      // hide expand icon cell
      '& div[data-tag="expander"]': {
        display: "none",
      },
    },
  },
];

export const conditionalRowStylesTournament = [
  {
    when: (row) => row,
    style: {
      borderRadius: "30px",
      backgroundColor: "#0a0a0a",
      color: "#bbb",
    },
  },
];

export const conditionalRowStylesPlayer = [
  {
    when: (row) => row.PlayerId % 2 === 0,
    style: {
      borderRadius: "30px",
      backgroundColor: "#0a0a0a",
      color: "#bbb",
    },
  },
];

export const conditionalRowStylesMatches = [
  {
    when: (row) => row.id % 2 == 0,
    style: {
      borderRadius: "30px",
      backgroundColor: "#0a0a0a",
      color: "#bbb",
    },
  },
];
export const conditionalRowStylesUmpire = [
  {
    when: (row) => row.id % 2 === 0,
    style: {
      borderRadius: "30px",
      backgroundColor: "#0a0a0a",
      color: "#bbb",
    },
  },
];

export const conditionalRowStylesGround = [
  {
    when: (row) => row.id % 2 === 0,
    style: {
      borderRadius: "30px",
      backgroundColor: "#0a0a0a",
      color: "#bbb",
    },
  },
];

export const customtableumpireassesmentStyles = {
  headRow: {
    style: {
      borderRadius: "30px",
      backgroundColor: "var(--table-header)",
      color: "var(--text-color)",
      fontWeight: "bold",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: "white",
      margin: "0px",
    },
  },

  rows: {
    style: {
      fontSize: "16px",

      borderRadius: "30px",
      color: "var(--text-color)",
      height: "60px",
      "&:nth-child(2n)": {
        backgroundColor: "var(--row-color)",
      },
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
};

export const custombatsmanbowlertableStyles = {
  headRow: {
    style: {
      backgroundColor: "#DEE6FF",
      color: "#5D6B95",
      fontWeight: "400",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: "#5D6B95",
      margin: "0px",
    },
  },

  rows: {
    style: {
      color: "#22242C",
      height: "60px",
      borderBottom: "2px solid #C2C2C4",
      "&:nth-child(2n)": {
        backgroundColor: "#3350BD1A",
      },
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
};

// ✅ Custom Styles for DataTable
export const displayBallsStyles = {
  headRow: {
    style: {
      backgroundColor: "#FFF",
      color: "#5D6B95",
      fontWeight: "400",
      borderTop: "2px solid #DBDDE2",
      borderBottom: "2px solid #DBDDE2",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      color: "#5D6B95",
      margin: "0px",
      borderRight: "1px solid #C2C2C4",
    },
  },
  rows: {
    style: {
      color: "#22242C",
      fontSize: "12px",
      height: "40px",
      borderBottom: "1px solid #C2C2C4",
      cursor: "pointer",
      transition: "background-color 0.2s ease",

      // ✅ Hover effect
      "&:hover": {
        backgroundColor: "#e0e0e0 !important",
      },

      // ✅ Active (when row is clicked/held down)
      "&:active": {
        backgroundColor: "#d0d0d0 !important",
      },
    },
  },
  cells: {
    style: {
      borderRight: "1px solid #C2C2C4",
      paddingLeft: "4px",
      paddingRight: "4px",
    },
  },
};



export const custombatsmanbowlertableStylesExpandable = {
  headRow: {
    style: {
      // height: "0px",
      // minHeight: "0px",
      // maxHeight: "0px",
      // padding: "0px",
      // border: "none",
      // visibility: "hidden",
      display: "none",
    },
  },
  headCells: {
    style: {
      // height: "0px",
      // minHeight: "0px",
      // maxHeight: "0px",
      // padding: "0px",
      // border: "none",
      // visibility: "hidden",
      display: "none",
    },
  },
  rows: {
    style: {
      color: "#22242C",
      height: "48px",
      borderBottom: "1px solid #E2E2E2",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  cells: {
    style: {
      paddingLeft: "0px", // Align with outer table columns
    },
  },
};
